import React from "react";
import LegalLayout from "./LegalLayout";
import { CONSENT_KEY } from "@/components/CookieBanner";

const CONTENT = {
    nl: {
        title: "Cookiebeleid",
        updated: "juni 2026",
        sections: [
            { h: "Wat zijn cookies en lokale opslag", p: ["Cookies en lokale opslag (localStorage) zijn kleine stukjes informatie die je browser bewaart. We gebruiken ze om het platform te laten werken en — enkel met jouw toestemming — om anoniem gebruik te meten."] },
            { h: "Noodzakelijk (altijd actief)", p: ["Login-token: houdt je aangemeld.", "Taalkeuze (vsf_lang): onthoudt je gekozen taal.", "Voorkeuren: bv. lettergrootte van de autocue, prijszichtbaarheid.", "Cookie-voorkeur (vsf_cookie_consent): onthoudt je keuze in de cookiebanner.", "Hiervoor is geen toestemming vereist — zonder deze opslag werkt het platform niet."] },
            { h: "Analytisch (enkel na toestemming)", p: ["PostHog: anonieme statistieken over paginabezoeken en productgebruik zodat we het platform kunnen verbeteren. Deze tool wordt pas geladen nadat je in de cookiebanner op \"Accepteren\" klikt. Kies je \"Weigeren\", dan wordt er niets gemeten."] },
            { h: "Je keuze aanpassen", p: ["Je kan je keuze op elk moment intrekken of wijzigen met de knop hieronder. Daarnaast kan je cookies altijd verwijderen via de instellingen van je browser."] },
            { h: "Contact", p: ["Vragen over dit beleid? Mail naar {{email}}. Zie ook onze privacyverklaring."] },
        ],
        btn: "Cookie-keuze opnieuw instellen",
        btnDone: "Keuze gewist — de banner verschijnt opnieuw.",
    },
    fr: {
        title: "Politique de cookies",
        updated: "juin 2026",
        sections: [
            { h: "Cookies et stockage local", p: ["Les cookies et le stockage local (localStorage) sont de petites informations conservées par votre navigateur. Nous les utilisons pour faire fonctionner la plateforme et — uniquement avec votre consentement — mesurer l'utilisation de façon anonyme."] },
            { h: "Nécessaires (toujours actifs)", p: ["Jeton de connexion : vous maintient connecté.", "Choix de langue (vsf_lang).", "Préférences : p.ex. taille de police du prompteur.", "Préférence cookies (vsf_cookie_consent) : mémorise votre choix.", "Aucun consentement requis — sans ce stockage, la plateforme ne fonctionne pas."] },
            { h: "Analytiques (après consentement uniquement)", p: ["PostHog : statistiques anonymes sur les visites et l'utilisation du produit. Cet outil n'est chargé qu'après avoir cliqué sur « Accepter » dans la bannière. Si vous refusez, rien n'est mesuré."] },
            { h: "Modifier votre choix", p: ["Retirez ou modifiez votre choix à tout moment avec le bouton ci-dessous, ou supprimez les cookies via les paramètres de votre navigateur."] },
            { h: "Contact", p: ["Questions ? {{email}}. Voir aussi notre déclaration de confidentialité."] },
        ],
        btn: "Réinitialiser le choix de cookies",
        btnDone: "Choix effacé — la bannière réapparaîtra.",
    },
    en: {
        title: "Cookie Policy",
        updated: "June 2026",
        sections: [
            { h: "Cookies and local storage", p: ["Cookies and local storage are small pieces of information kept by your browser. We use them to make the platform work and — only with your consent — to measure usage anonymously."] },
            { h: "Necessary (always active)", p: ["Login token: keeps you signed in.", "Language choice (vsf_lang).", "Preferences: e.g. teleprompter font size.", "Cookie preference (vsf_cookie_consent): remembers your banner choice.", "No consent required — without this storage the platform does not work."] },
            { h: "Analytics (only after consent)", p: ["PostHog: anonymous statistics about page visits and product usage so we can improve the platform. This tool only loads after you click \"Accept\" in the cookie banner. If you decline, nothing is measured."] },
            { h: "Change your choice", p: ["Withdraw or change your choice anytime with the button below, or delete cookies via your browser settings."] },
            { h: "Contact", p: ["Questions? {{email}}. Also see our privacy policy."] },
        ],
        btn: "Reset cookie choice",
        btnDone: "Choice cleared — the banner will reappear.",
    },
    es: {
        title: "Política de cookies",
        updated: "junio de 2026",
        sections: [
            { h: "Cookies y almacenamiento local", p: ["Las cookies y el almacenamiento local son pequeñas piezas de información que guarda su navegador. Las usamos para que la plataforma funcione y — solo con su consentimiento — para medir el uso de forma anónima."] },
            { h: "Necesarias (siempre activas)", p: ["Token de inicio de sesión: le mantiene conectado.", "Idioma elegido (vsf_lang).", "Preferencias: p.ej. tamaño de letra del teleprompter.", "Preferencia de cookies (vsf_cookie_consent): recuerda su elección.", "No se requiere consentimiento — sin este almacenamiento la plataforma no funciona."] },
            { h: "Analíticas (solo tras consentimiento)", p: ["PostHog: estadísticas anónimas sobre visitas y uso del producto. Esta herramienta solo se carga después de hacer clic en \"Aceptar\" en el banner. Si rechaza, no se mide nada."] },
            { h: "Cambiar su elección", p: ["Retire o cambie su elección en cualquier momento con el botón de abajo, o elimine las cookies en la configuración de su navegador."] },
            { h: "Contacto", p: ["¿Preguntas? {{email}}. Consulte también nuestra política de privacidad."] },
        ],
        btn: "Restablecer elección de cookies",
        btnDone: "Elección borrada — el banner volverá a aparecer.",
    },
};

export default function CookiePolicy() {
    const reset = () => {
        try { localStorage.removeItem(CONSENT_KEY); } catch {}
        window.location.reload();
    };
    const lang = (localStorage.getItem("vsf_lang") || "nl").slice(0, 2);
    const c = CONTENT[lang] || CONTENT.nl;
    return (
        <LegalLayout
            docKey="cookies"
            content={CONTENT}
            footerExtra={
                <button
                    type="button"
                    onClick={reset}
                    className="mt-8 h-11 px-5 bg-zinc-950 text-white text-sm font-bold rounded-sm hover:bg-zinc-800 active:scale-95 transition"
                    data-testid="cookie-reset-btn"
                >
                    {c.btn}
                </button>
            }
        />
    );
}
